import Head from './pages/header'
import Bottom from './pages/bottom'
import EG from './eg/eg'
import Text from './eg/text'
import Map from './pages/map'
import Divider from './pages/divider'
import "./index.css"

function App() {
  return (
    <>
    <Head></Head>
    <EG></EG>
    <Text></Text>
    <Divider></Divider>
    <Map></Map>
    <Bottom></Bottom>
    </>
  );
}

export default App;
